// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3588":"32500903","7238":"a8339fae"}[chunkId] + ".chunk.css";
};